import { z } from 'zod';
export const CategorySearchSchema = z.object({
  freeText: z.string().default(''),
  integratableOnly: z.boolean().default(false),
  page: z.number().default(1),
  pageSize: z.number().default(20)
});
export type CategorySearchParams = z.infer<typeof CategorySearchSchema>;